import { Component, OnInit } from '@angular/core';
import { AIChatAPI } from 'src/app/services/api-service/ai-chat-api';

@Component({
  selector: 'app-gomoku',
  templateUrl: './gomoku.component.html',
  styleUrls: ['./gomoku.component.css']
})
export class GomokuComponent implements OnInit {

  grid:cell[][]=[]
  history:{row:number,col:number,type:'b'|'w'}[]
  cellSize = 30;
  msg:string = '';
  num = 0;
  prompt1 = `你是一個高段位五子棋 AI，扮演白子玩家。每次分析棋盤時，請遵守以下流程：
**先檢查勝負**：
   - 如果白子已無法形成連五（投降），回傳 {"row":-1,"col":-1}。`;
  prompt = `**黑子威脅優先阻擋**：
   - 任何黑子在下一步或兩步內有可能形成五連、活四、衝四、雙活三，白子**必須立即阻擋**。
   - 即使白子有活四或可以直接連五，也必須先阻擋黑子威脅。
   - 若黑子有潛在多線威脅，也應優先破壞
   - 考慮黑子下的最後一手可能的進攻意圖，加以破壞
**白子獲勝手**：
   -  如果白子有直接獲勝手（五連補點），在安全的前提下選擇白子獲勝。
**全局策略**（當沒有立即勝負或威脅時）：
   - 建立白子的活三、雙三或多線威脅，分析橫、直、斜三個方向。
   - 創造誘敵陷阱，逼迫對手下出對自己有利的棋。
   - 控制全局節奏，不只單線連五，還要考慮多線威脅和未來潛力。   
   - 如果有多個合理候選點，先列出 3~5 個候選點，再選出唯一最佳落子，避免增加黑子優勢。`
  constructor(private ai:AIChatAPI) {


   }

  ngOnInit(): void {
  }
  rsPlayer:()=>void;
  initGame(){
    this.grid = Array(15).fill('').map(x=>{
      return Array(15).fill('').map(y=>{
        return {type:'',num:0}
      });
    })
    this.history = [];
    this.isOver = false;
    setTimeout(async () => {
      while(!this.isOver){
        await new Promise<void>((rs,rj)=>{
          this.msg = '輪到你了'
          this.rsPlayer = rs;
        })
        if(this.isOver){
          break;
        }
        this.msg = '電腦思考中...'
        await this.AIRound()
      }  
    }, 0);
    
  }
  async AIRound(){
    
    var 子 = []
    //改落子順序
    this.grid.forEach((x,i)=>{
      x.forEach((y,j)=>{
        if(y.type!=''){
          子.push({row:i,col:j,type:y.type})
        }
      })
    });
    var msg = this.prompt1+`
    ` + this.prompt +
    `
**回傳格式**：
   - 必須是純文字 JSON，不加 Markdown code block 或多餘文字：
     {"row":number,"col":number}
**棋盤資料**：
   - 棋盤大小為 15x15，row 和 col 從 0 開始。
   - 只列出已有棋子，type 'w' 表示白子，type 'b' 表示黑子。
   - 資料順序為落子順序：\n`
    +JSON.stringify(this.history)+'\n'
    //+`請 **不要加任何 Markdown code block**,只回傳純文字 JSON {"row":number,"col":number}。`
    var result = await this.ai.CompleteNoPrompt(msg);
    console.log(result)
    var ret = JSON.parse(result[0].Content) as {row:number,col:number};
    if(ret.row == -1){
      this.msg = '電腦投降'
      this.isOver = true;
      return 
    }
    this.grid[ret.row][ret.col].type='w'
    this.grid[ret.row][ret.col].num = ++this.num;
    this.history.push({row:ret.row,col:ret.col,type:'w'})
    this.checkGameOver()
  }
  cellClick(row,col){
    if(!this.isOver&& this.rsPlayer != null && this.grid[row][col].type==''){
      this.grid[row][col].type = 'b';
      this.grid[row][col].num = ++this.num;
      this.history.push({row,col,type:'b'})
      this.checkGameOver()
      this.rsPlayer();
      this.rsPlayer = null
    }
    
  }
  checkWinner(): 'w' | 'b' | '' {
    const SIZE = this.grid.length;

    // 四個方向：右、下、右下、左下
    const directions = [
        [0, 1],   // 水平
        [1, 0],   // 垂直
        [1, 1],   // 右下斜
        [1, -1]   // 左下斜
    ];

    for (let r = 0; r < SIZE; r++) {
        for (let c = 0; c < SIZE; c++) {
            const current = this.grid[r][c].type;
            if (!current) continue;

            for (const [dr, dc] of directions) {
                let count = 1;
                let nr = r + dr;
                let nc = c + dc;

                while (
                    nr >= 0 && nr < SIZE &&
                    nc >= 0 && nc < SIZE &&
                    this.grid[nr][nc].type === current
                ) {
                    count++;
                    if (count >= 5) return current;
                    nr += dr;
                    nc += dc;
                }
            }
        }
    }

    return '';
}
  checkGameOver(){
    var winner = this.checkWinner();
    
    if(winner == 'w'){
      this.msg = '電腦贏了'
      this.isOver = true;
      return 
    }
    if(winner == 'b'){
      this.msg = '你贏了'
      this.isOver = true;
      return 
    }
  }
  isOver:boolean = false;
  show:boolean = false;
  open(){
    this.show = true;
  }
  close(){
    this.show = false;
  }
}

interface cell{
  type:''|'b'|'w',
  num:number;
}